import { FETCH_MENUS, TOGGLE_MENU, CLOSE_MENU } from "../actions/types";

const INITIAL_STATE = {
  open: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MENUS:
      return { ...state, menus: action.payload.data };
    case TOGGLE_MENU:
      return { ...state, open: !state.open };
    case CLOSE_MENU:
      return { ...state, open: false };
    default:
      return state;
  }
};
